<ul role="tablist" class="svelte-tabs__tab-list">
  <slot></slot>
</ul>
